import React, { Component } from 'react';
import { message, Table , Spin, Button } from 'antd'
import axios from 'axios'

class AlertLog extends Component {

    state ={
        loading :false,
        data : [],
        pagination :{
            current : 1,
            pageSize : 10
        }
    }

    componentDidMount(){
        const {pageSize , current } = this.state.pagination
        this.fetchSentMessages({
           limit : pageSize , 
           offset:(current - 1)*pageSize
        })
    }

    fetchSentMessages = (params) => {
        this.setState({
            loading:true
        },
        () => {
            axios.get("/api/alert/sms/",{params:params})
            .then(response => {
                const pagination = {total : response.data.count , ...this.state.pagination }
                this.setState({
                    data: response.data.results,
                    pagination : pagination
                })
            })
            .catch(err =>{
                console.error(err);
                message.error("Something wrong with sending alerts! Please try again later.")       
                }       
            ).finally(()=>{
                this.setState({loading:false})
            })
            
        } 
        )
       
    }

    handleTableChange = ({current , pageSize}) => {
        this.setState({
            pagination:{current , pageSize }
        }
        ,() =>{
            this.fetchSentMessages({
                limit : pageSize,
                offset : (current - 1) * pageSize
            })
        }
        )
    }

    

    columns = [
        {   
            key : 0,
            title : "Mobile No",
            dataIndex : "to_mobile_number"
        }
        ,
        {   
            key : 1,
            title : "Message",
            dataIndex : "message"
        }
        ,
        {
            key : 1,
            title : "Sent Status",
            dataIndex : "is_sent",
            render : is_sent=> is_sent ? "Success" : "Failed"
        },

        {   
            key : 2,
            title : "",
            dataIndex : "last_modified",
            render : date => date


        }
    ]
   
    render() { 
        return ( 
           
            <Table
                columns={this.columns}
                dataSource = {this.state.data}
                pagination = {this.state.pagination}
                onChange = {this.handleTableChange}
                loading = {this.state.loading}
             />
            
         );
    }
}
 
export default AlertLog;